import React from 'react'
import ProLayout from '@ant-design/pro-layout'
import _ from 'lodash'
import config, { menuItems } from '../../constants/menu-config'

export default ({ children, menu }) => {
  const filteredChild = menuItems.map((v) => {
    if (!_.isEmpty(v.children)) {
      const mapped = {
        ...v,
        children: v.children.filter(i => _.includes(menu, i.id)),
      }
      return mapped
    } return v
  })

  const renderMenu = filteredChild.filter(v => _.includes(menu, v.id) || v.id === 'home' || (v.id === '#' && !_.isEmpty(v.children)))

  return (
    <ProLayout
      route={{
        routes: renderMenu,
      }}
      {...config}
    >
      {
        children
      }
    </ProLayout>
  )
}
